import { query, redirect } from "@solidjs/router";
import { getCookie } from "./utils.js";
import { createContext } from "solid-js";

export const getCurrentUserRaw = async () => {
  const token = getCookie("token");

  if (!token) {
    // No token, so we know we need to log in.
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  let response;
  try {
    response = await fetch("/api/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    // This catches network errors.
    console.error("Network error fetching user:", error);
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  if (response.status === 401) {
    // Token is invalid/expired, clear it and redirect.
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  if (!response.ok) {
    // Another server error occurred.
    console.error(`Failed to fetch user: ${response.statusText}`);
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  // All good, return user data.
  return await response.json();
}

// This is the query function that fetches user data.
// The router understands how to handle redirects thrown from here.
export const getCurrentUser = query(getCurrentUserRaw, "currentUser"); // "currentUser" is the cache key for this query.

// The preload function's only job is to trigger the query.
export function protectedLoader() {
  void getCurrentUser();
}

export const getUsersRaw = async () => {
  const token = getCookie("token");
  const response = await fetch("/api/users", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch users");
  }
  return await response.json();
}

export const getUsers = query(getUsersRaw, "users");

export const hasRole = (user, role) =>
  user?.roles?.some((r) => r.role === "admin" || r.role === role) ?? false;

export const isAdmin = (user) => hasRole(user, "admin");

export const UserContext = createContext();
